
const TollReliefConfig = {
    labels: {
        componentLoader: 'One moment please...',
    },
    urls: {
        tollTrackerURL: process.env.REACT_APP_TOLL_TRACKER_URL ?? '',
        tollReliefRebateSchemeURL: 'https://www.service.nsw.gov.au/services/toll-relief',
        myServiceNswAccountOverviewURL: 'https://account.service.nsw.gov.au/overview',
    },
    tr3TermsDecisionCookie: {
        name: 'tr3-terms-decision',
        monthsValidFor: 3,
    },
    anchors: { // Page anchors that errors can link to. Will appear be in uri.
        tollProvider: 'toll-provider',
        tollAccountNumber: 'toll-account-number',
        licensePlateNumber: 'license-plate-number',
        evidenceOfBusinessTurnover: 'evidence-business-turnover',
        mainEmail: 'main-email',
        rideshare: 'rideshare',
        agreeToTr2PersonalTerms: 'terms-2',
        agreeToTr3PersonalTerms: 'terms-3',
        agreeToTr2SoleTraderTerms: 'terms-trader',
        abn: 'abn',
    },
    queryParams: {
        clearCookie: 'clear-cookie',
    }
};

export default TollReliefConfig;
